import { useLogger } from '../providers/logger/Logger';
import { useMutation } from '@apollo/react-hooks';
import { useViewTracker } from '../providers/ViewTrackerProvider';
import { useParams } from 'react-router-dom';
import { Article, ArticleViewStatAdd, CampaignTypeCode } from '../../shared/types'
import { useRouteMatch } from 'react-router-dom';
import gql from 'graphql-tag';

enum EmailLinkTypes {
	EmailLink = 'el',
	EmailButton = 'eb'
}

export const ADD_ARTICLESTAT = gql`
mutation addArticleViewStat($item: ArticleViewStatAdd) {
	addArticleViewStat(item: $item) {
		type
		source
		articleId
		tags { _id name }
		categories { _id name }
		desk { _id name }
	}
}`;

const toViewStatsType = (source: string, campaignShortCode: CampaignTypeCode | string, isMarketingArticle: boolean) =>
	isMarketingArticle ? 'Marketing' :
	campaignShortCode === 'l' ? 'LinkCampaign' :
	campaignShortCode === 'e' ? 'EmailCampaign' :
	campaignShortCode === 't' ? 'Twitter' :
	campaignShortCode === 'li' ? 'LinkedIn' :
	campaignShortCode === 'fb' ? 'Facebook' :
	campaignShortCode === 'qr' ? 'QrCode' :
	source === '' ?
		campaignShortCode === 'el' ? 'PublishArticleEmailLink' :
		campaignShortCode === 'eb' ? 'PublishArticleEmailButton' :
		campaignShortCode === 'w' ? 'MarexWebsiteLink' :
		'Link' :
		'Page';

const toNameAndId = (p: { _id: string; name: string }) => ({ _id: p._id, name: p.name });

export const useViewStats = () => {
	const { campaignIdAndType } = useParams<{ campaignIdAndType: string}>();
	const { source, sourceId, sourceDetail } = useViewTracker();
	const { sessionInfo } = useLogger();
	const isMarketingArticle = !!useRouteMatch('/browse/marketing-article/:_id');
	const [addArticleViewStats] = useMutation<any, { item: ArticleViewStatAdd }>(ADD_ARTICLESTAT);

	const addViewStats = (article: Article) => {
		const campaignId = campaignIdAndType?.split('|')?.[0]
		const campaignShortcut = campaignIdAndType?.split('|')?.[1] as CampaignTypeCode;
		const type = toViewStatsType(source, campaignShortcut || campaignId, isMarketingArticle);
		const isLinkFromEmail = campaignId === EmailLinkTypes.EmailLink || campaignId === EmailLinkTypes.EmailButton;

		const articleViewStatAdd = {
			type,
			source: !isLinkFromEmail ? (campaignId || source) : type,
			sourceId,
			sourceDetail,
			session: sessionInfo.sessionId,
			articleId: article._id,
			title: article.title,
			tags: article.tags.map(toNameAndId),
			categories: article.categories.map(toNameAndId),
			desk: article.publishedBy.type === 'desk' ? toNameAndId(article.publishedBy) : undefined,
			isPremium: article.isPremium
		};

		addArticleViewStats({ variables: { item: articleViewStatAdd } });
	}

	return addViewStats;
}
